import { render, staticRenderFns } from "./InventoryView.vue?vue&type=template&id=04a402b1&scoped=true&"
import script from "./InventoryView.vue?vue&type=script&lang=ts&"
export * from "./InventoryView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a402b1",
  null
  
)

export default component.exports